import { offlineDb } from './db';

export type OfflineImageVariant = 'medium' | 'thumb';

const objectUrls = new Map<string, string>();

export function offlineImageKey(assetId: string, variant: OfflineImageVariant): string {
  return `${assetId}:${variant}`;
}

/** Resolve a stored image blob to an object URL (cached for the page lifetime). */
export async function resolveOfflineImageUrl(
  assetId: string,
  variant: OfflineImageVariant,
): Promise<string | null> {
  const key = offlineImageKey(assetId, variant);
  const cached = objectUrls.get(key);
  if (cached) return cached;
  let stored = await offlineDb.offlineImages.get(key);
  if (!stored) {
    // Fall back to the other variant so a thumbnail can stand in for a missing medium image.
    stored = await offlineDb.offlineImages.get(
      offlineImageKey(assetId, variant === 'medium' ? 'thumb' : 'medium'),
    );
  }
  if (!stored) return null;
  const url = URL.createObjectURL(stored.blob);
  objectUrls.set(key, url);
  return url;
}

export function revokeOfflineImageUrls() {
  for (const url of objectUrls.values()) URL.revokeObjectURL(url);
  objectUrls.clear();
}
